export type GallerySpan = 'large' | 'wide';

export type GalleryItem = {
  id: string;
  label: string;
  image: string;
  color: string;
  span?: GallerySpan;
};

export const GALLERY_COLORS = ['tomato', 'sky', 'grass', 'sun', 'grape', 'bubble'] as const;

export const GALLERY_COLOR_BG: Record<string, string> = {
  tomato: 'bg-tomato',
  sky: 'bg-sky',
  grass: 'bg-grass',
  sun: 'bg-sun',
  grape: 'bg-grape',
  bubble: 'bg-bubble',
};

export const SPAN_CLASS: Record<string, string> = {
  large: 'sm:col-span-2 sm:row-span-2',
  wide: 'sm:col-span-2',
};

export async function listGallery(): Promise<GalleryItem[]> {
  const res = await fetch('/api/gallery');
  if (!res.ok) throw new Error('Kunde inte hämta galleri');
  return res.json() as Promise<GalleryItem[]>;
}

export async function createGalleryItem(item: GalleryItem): Promise<GalleryItem[]> {
  const res = await fetch('/api/gallery', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(item),
  });
  if (!res.ok) {
    const { error } = await res.json() as { error: string };
    throw new Error(error);
  }
  return res.json() as Promise<GalleryItem[]>;
}

export async function updateGalleryItem(id: string, item: GalleryItem): Promise<GalleryItem[]> {
  const res = await fetch(`/api/gallery/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(item),
  });
  if (!res.ok) {
    const { error } = await res.json() as { error: string };
    throw new Error(error);
  }
  return res.json() as Promise<GalleryItem[]>;
}

export async function deleteGalleryItem(id: string): Promise<GalleryItem[]> {
  const res = await fetch(`/api/gallery/${encodeURIComponent(id)}`, { method: 'DELETE' });
  if (!res.ok) {
    const { error } = await res.json() as { error: string };
    throw new Error(error);
  }
  return res.json() as Promise<GalleryItem[]>;
}
